import cloneDeep from 'lodash/cloneDeep';

window.appKey = 'ZnMMwPw0XvmuJQWV2OGcvpe4cuWHfoIwhSFjo1B7';
window.restAPIKey = 'EedaJqfHdzFMJa6AmajM04a9vTSCkUi2xjlRY7ID';

const mmcUtils = {
  env: window.theEnvironment,

  tk: function tk() {
    // track gmaps counters
    if (this.env === 'production') {
      console.log("it's prod...");
      // this.promisifiedAjax({method: "POST", url: "/1/et/" + event});
    }
  },

  standardHeaders: {}, // dynamically set by login.js controller.

  appInit(accessToken) {
    if (!accessToken && !['register', 'reset-password', 'forgot-password', 'login'].some(window.isOnPage)) {
      window.location.href = '#/login';
    }
  },

  showValidationError(e, message = 'Something went wrong, please try again later') {
    if (e && Array.isArray(e.validationErrors) && e.validationErrors.length) {
      message = e.validationErrors[0].message;
    }
    swal('Uh-oh', message, 'error');
  },

  buildCompleteAddress(addressJSON) {
    return ['address', 'city', 'region', 'postalCode', 'country']
      .filter(field => !!addressJSON[field])
      .map(field => addressJSON[field])
      .join(', ');
  },

  setViewByUserBasedOnRole(storage) {
    const {role} = storage.currentUser;
    return (role && (role.key === 'OWNER' || role.key === 'MANAGER'));
  },

  setLeadsView(currentState) {
    return currentState && currentState.user ? currentState.user : undefined;
  },

  convertGeoPointToString(geoPoint) {
    return `${parseFloat(geoPoint.coordinates[1]).toFixed(5)},${parseFloat(geoPoint.coordinates[0]).toFixed(5)}`;
  },

  convertStringToGeoPoint(geoPointString) {
    const arr = geoPointString.split(',');
    return {
      type: 'Point',
      coordinates: [parseFloat(arr[1]).toFixed(5), parseFloat(arr[0]).toFixed(5)],
    };
  },

  getIdFromCurrentUrl() {
    return parseInt(window.location.href.substring(window.location.href.lastIndexOf('/') + 1), 10);
  },

  // find the user-agent (device being used)
  isMobile: {

    Windows() {
      return /IEMobile/i.test(navigator.userAgent);
    },
    Android() {
      return /Android/i.test(navigator.userAgent);
    },
    BlackBerry() {
      return /BlackBerry/i.test(navigator.userAgent);
    },
    iOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    Edge() {
      return /Edge/i.test(navigator.userAgent);
    },
    Trident() {
      return /Trident/i.test(navigator.userAgent);
    },
    any() {
      return (this.Android() || this.BlackBerry() || this.iOS() || this.Windows());
    },

  },

  isOnPage: (...pages) => pages.some(page => page === window.mmcUtils.MAN.$route.current.id),

  isNotOnPage(...pages) {
    return !this.isOnPage(...pages);
  },

  jsonClone(object) {
    try {
      return cloneDeep(object);
    } catch (e) {
      console.error('Probably tried to clone an unclonable object:', e, object);
    }
  },

  // supports callbacks and promises
  // show loading gif,
  // go to a page,
  // wait for loading gif to be hidden
  // then do either what's in callback, or resolve promise
  navigateAndThen(page, callback) {
    console.log("let's go:", page, callback);
    return new Promise((resolve) => {
      window.DataModel.show.loader = true;
      window.location = `#/${page}`; // e.g., "contacts";
      const theInt = setInterval(() => {
        if (!window.DataModel.show.loader) {
          clearInterval(theInt);
          if (callback) callback();
          resolve();
        }
      }, 100);
    });
  },

  getRandomInRange(min, max) {
    return Math.random() * (max - min) + min;
  },

  mL(a, b) {
    this.promisifiedAjax({
      method: 'POST',
      url: `${mmcUtils.internalBase}mL/`,
      headers: {'Content-Type': 'application/json; charset=UTF-8'},
      data: JSON.stringify({a, b}),
    })
      .then((data) => {
        window.parseHeaders = data.h;
        swal(':)', '', 'success');
      })
      .catch(() => {
        swal('!', '', 'error');
      });
  },

  safeParse(input) {
    const origin = new Error().stack;
    try {
      if (typeof input === 'string') {
        if (input === '') {
          throw new Error("LIKELY BUG: Can't JSON.parse an empty string. This could be a problem.");
        } else {
          return JSON.parse(input);
        }
      } else if (typeof input === 'object' && input !== null) {
        console.warn("POTENTIAL BUG VECTOR: Can't JSON.parse a non-string, but it's either an object or array, so we'll assume this was an already-parsed object. Need to attempt to fix the root cause.");
        return input;
      } else {
        throw new Error(`Can't JSON.parse a non-string, AND can't return because it's not an object, it's: ${typeof input}`);
      }
    } catch (e) {
      console.error('FAILED JSON PARSE: something really broke... you tried to parse a non-string, non-object?', {e, origin, input});
      throw new Error({e, origin, input});
    }
  },

  sendLogs(all) {
    if (mmcUtils.env === 'development') console.warn("Note, no logs are recorded on local unless you use '#debug'.");

    this.promisifiedAjax({
      method: 'POST',
      url: `${mmcUtils.internalBase}sendLogs/`,
      headers: {'Content-Type': 'application/json; charset=UTF-8'},
      data: JSON.stringify({
        logs: all ? window.hiddenLogs : window.hiddenLogs.slice(window.hiddenLogs.length - 50, window.hiddenLogs.length),
      }),
    })
      .then(() => {
        swal('Thanks', "We've received that info.", 'success');
      })
      .catch(() => {
        swal('Uh oh', "That didn't work quite right. You may try again.", 'error');
      });
  },

  sendFlagRetry: 0,

  sendFlag(data) {
    return (this.promisifiedAjax || window.mmcUtils.promisifiedAjax)({
      method: 'POST',
      url: `${mmcUtils.internalBase}flag`,
      headers: {'Content-Type': 'application/json; charset=UTF-8'},
      data: JSON.stringify(data),
    })
      .catch(() => {
      });
  },

  sendExperiment(id, status, details) {
    return this.promisifiedAjax({
      method: 'POST',
      url: `${mmcUtils.internalBase}experiment/${id}`,
      headers: {'Content-Type': 'application/json; charset=UTF-8'},
      data: JSON.stringify({
        status,
        details,
      }),
    });
  },

  hackyWaitForLoadingGifShowAndHide(purpose) {
    const startTime = new Date();
    return new Promise((resolve) => {
      console.log('onLoadingGifHide(): setting a hacky onLoadingGifHide promise for', purpose);

      // first we wait to make sure the loading gif actually shows in case we're just a little early
      // but we only give it a second
      let shownCheckCounter = 0;
      const waitForShownInterval = setInterval(
        () => {
          shownCheckCounter++;
          if (window.DataModel.show.loader || shownCheckCounter > 19) {
            const shownTime = new Date();
            console.log(`onLoadingGifHide(): loadingGif is now showing for ${purpose} promise, took ${(shownTime - startTime) / 1000} seconds`);
            clearInterval(waitForShownInterval);

            // then we wait for the loading gif to hide
            const waitForHiddenInterval = setInterval(
              () => {
                if (!window.DataModel.show.loader) {
                  const endTime = new Date();
                  console.log(`onLoadingGifHide(): resolving promise for ${purpose}, took ${(endTime - startTime) / 1000} seconds total`);
                  clearInterval(waitForHiddenInterval);
                  resolve();
                }
              }, 100,
            );
          }
        }, 50,
      ); // wait for shown
    }); // promise
  },

  promisifiedAjax(connectionSettings) {
    return new Promise((resolve, reject) => {
      $.ajax(connectionSettings)
        .fail((xhr, status, error) => reject({xhr, status, error})) // eslint-disable-line prefer-promise-reject-errors
        .then(resolve);
    });
  },

  // fetches all customers directly from redis with internal endpoint
  fetchRecordsNode(data, table) {
    console.log('fetch url ', `${mmcUtils.internalBase}${table}/fetch/${encodeURI(JSON.stringify(data))}`);
    const fetchRecords = () => this.promisifiedAjax({
      method: 'GET',
      url: `${mmcUtils.internalBase}${table}/fetch/${encodeURI(JSON.stringify(data))}`,
    });

    return new Promise((resolve) => {
      resolve(fetchRecords());
    });
  },

  // fetches and saves customers directly from the database with internal endpoint
  fetchAndSaveRecordsNode(data, table) {
    const fetchAndSaveRecords = () => this.promisifiedAjax({
      method: 'GET',
      url: `${mmcUtils.internalBase}${table}/fetchandsave/${encodeURI(JSON.stringify(data))}`,
    });

    return new Promise((resolve) => {
      resolve(fetchAndSaveRecords());
    });
  },

  uniqueArray(arrayWithPotentialDuplicates) {
    return Object.keys(arrayWithPotentialDuplicates.reduce(
      (memo, item) => {
        if (memo[item]) {
          return memo;
        }
        memo[item] = 1;
        return memo;
      }, {},
    ));
  },

  firstLoad: true,

  // HOTFIX; blank page or page with only map when utils.env === 'production' without this.
  debugMode: () => true, // || window.location.href.indexOf('#debug') >= 0 || window.mmcUtils.env === 'staging',

  // returns the correct pin background image for the map overlay, given a certain color
  validPinColors: [
    // "black", // this is the default, has an inconsistent image name.
    'green',
    'blue',
    'grey',
    'orange',
    'pink',
    'purple',
    'red',
    'teal',
    'yellow',
    'neon red',
    'neon yellow',
    'neon green',
    'neon blue',
    'neon purple',
    'white',
    'violet',
    'turquoise',
    'peach',
    'navy',
    'olive',
    'cyan',
    'gold',
    'maroon',
    'brown',
  ],

  getPinImageForColor(color) {
    color = window.mmcUtils.validPinColors.indexOf(color) >= 0 ? `_${color.replace(/ /g, '_')}` : '';
    return `url('${window.DataModel.MappingService.pinDir + color}.png')`;
  },

  getCheckInPinImageForVisitDate(lastVisit, oldestVisitInDays, checkInDir) {
    const given = moment(lastVisit, 'YYYY-MM-DD');
    const current = moment().startOf('day');

    // Difference in number of days
    const lastVisitInDays = moment.duration(current.diff(given)).asDays();

    // scale is 0 --> 5 (white --> neon red)
    let color = '1';
    const segmentOne = oldestVisitInDays * (1 / 5);
    const segmentTwo = oldestVisitInDays * (2 / 5);
    const segmentThree = oldestVisitInDays * (3 / 5);
    const segmentFour = oldestVisitInDays * (4 / 5);
    if (lastVisitInDays <= segmentOne) color = '1';
    if (lastVisitInDays > segmentOne) color = '2';
    if (lastVisitInDays > segmentTwo) color = '3';
    if (lastVisitInDays > segmentThree) color = '4';
    if (lastVisitInDays > segmentFour) color = '5';
    return `url('${checkInDir}_${color}.svg')`;
  },

  reverseGeoCode(latlng) {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      window.mmcUtils.tk('aIDrFEziH1D');

      geocoder.geocode({location: latlng}, (results, status) => {
        console.log('geocode status: ', status, results);

        // found the address / or has lat/lng points
        if (status === google.maps.GeocoderStatus.OK) {
          const formattedResult = window.mmcUtils.formatReverseGeocode(results);
          // eslint-disable-next-line camelcase
          let street = formattedResult.street_number || '';
          street += (` ${formattedResult.route}`) || '';
          const address = typeof street === 'string' && street.trim() !== 'undefined' ? street : '';

          // eslint-disable-next-line camelcase
          let city = formattedResult.locality || formattedResult.neighborhood || formattedResult.administrative_area_level_3 || formattedResult.administrative_area_level_2;
          city = typeof formattedResult.locality === 'string' && formattedResult.locality.trim() !== 'undefined' ? formattedResult.locality : '';

          const country = typeof formattedResult.country === 'string' && formattedResult.country.trim() !== 'undefined' ? formattedResult.country : '';
          // eslint-disable-next-line camelcase
          const state = typeof formattedResult.administrative_area_level_1 === 'string' && formattedResult.administrative_area_level_1.trim() !== 'undefined' ? formattedResult.administrative_area_level_1 : '';
          // eslint-disable-next-line camelcase
          const zip = typeof formattedResult.postal_code === 'string' && formattedResult.postal_code.trim() !== 'undefined' ? formattedResult.postal_code : '';

          resolve({address, city, state, country, zip, status: 'OK'});
        } else {
          const errorArray = {status: 'error'};
          resolve(errorArray);
        }
      });
    });
  },

  geoCodeAddress(addressFull) {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      window.mmcUtils.tk('aIDrFEziH1D');

      geocoder.geocode({address: addressFull}, (results, status) => {
        console.log('geocode status: ', status, results);

        // found the address / or has lat/lng points
        if (status === google.maps.GeocoderStatus.OK) {
          let formattedArray;
          if (results[0].geometry.location.lat()) {
            const tempLat = parseFloat(results[0].geometry.location.lat()).toFixed(5);
            const tempLng = parseFloat(results[0].geometry.location.lng()).toFixed(5);
            const latitude = parseFloat(tempLat);
            const longitude = parseFloat(tempLng);
            formattedArray = {lat: latitude, lng: longitude, status: 'OK'};
          } else {
            formattedArray = {status: 'error'};
          }

          resolve(formattedArray);
        } else {
          const errorArray = {status: 'error'};
          resolve(errorArray);
        }
      });
    });
  },

  formatReverseGeocode(results) {
    const output = {};
    results[0].address_components.forEach(component => {
      component.types.forEach(type => {
        output[type] = component.long_name;
      });
    });
    return output;
  },
};

window.mmcUtils = mmcUtils;

window.hiddenLogs = [];
// end effect:
// you can simulate debug mode that exists in prod, while in localhost, by just using #debug like you would in prod.
// being in staging, is like being in prod with #debug.
// but in general, when local, you don't operate with this overhead, and get the cleanest possible message,
// without the availability of help() functioning.
if (window.mmcUtils.env === 'production' || window.mmcUtils.env === 'staging'
  || window.location.href.indexOf('#debug') >= 0
) {
  if (window.mmcUtils.debugMode()) console.warn('DEBUG MODE');
  else console.log('Welcome to Map My Customers! Hope everything is going well!');

  const oldLogger = console.log;
  const oldWarn = console.warn;
  const oldError = console.error;

  console.log = function (...args) {
    window.hiddenLogs.push({
      lvl: 'log',
      msg: args,
      stack: new Error().stack,
    });
    if (window.mmcUtils.debugMode()) oldLogger.apply(console, args, {stack: new Error().stack});
    if (window.hiddenLogs.length > 4000) window.hiddenLogs = window.hiddenLogs.slice(3000, 4000);
  };

  console.warn = function (...args) {
    window.hiddenLogs.push({
      lvl: 'warn',
      msg: args,
      stack: new Error().stack,
    });
    if (window.mmcUtils.debugMode()) oldWarn.apply(console, args, {stack: new Error().stack});
    if (window.hiddenLogs.length > 4000) window.hiddenLogs = window.hiddenLogs.slice(3000, 4000);
  };

  console.error = function (...args) {
    window.hiddenLogs.push({
      lvl: 'error',
      msg: args,
      stack: new Error().stack,
    });
    if (window.mmcUtils.debugMode()) oldError.apply(console, args, {stack: new Error().stack});
    if (window.hiddenLogs.length > 4000) window.hiddenLogs = window.hiddenLogs.slice(3000, 4000);
  };

  window.printHiddenLogs = function () {
    return window.hiddenLogs.map((log) => `${log.lvl}: ${log.msg[0]}`);
  };
}

window.help = mmcUtils.sendLogs;

export default mmcUtils;

// determine mmc-server uri
if (window.mmcUtils.env === 'production') {
  mmcUtils.internalBase = 'https://mapmycustomers.com/1/';
} else if (window.mmcUtils.env === 'staging') {
  mmcUtils.internalBase = 'https://159.203.165.82/1/';
} else if (window.mmcUtils.env === 'development') {
  mmcUtils.internalBase = 'https://159.203.165.82/1/';
  // mmcUtils.internalBase = "http://localhost:1339/1/";
}
